<div class="UNFAPP-chptr-insight-section">

        <mat-select *ngIf="totalSubjects?.length > 1" class="UNFAPP-chptr-insight-dropdown"  [(value)]="selectedSubject" (selectionChange)="subjectChange()" [disableOptionCentering]="true"  panelClass="UNFAPP-chptr-insight-dropdownlist">
            <mat-option *ngFor="let subject of totalSubjects" [value]="subject">
                {{subject}}
            </mat-option>
        </mat-select>

    <!-- <select [(ngModel)]="selectedSubject" (change)="subjectChange()">
        <option *ngFor="let subject of totalSubjects" value="{{subject}}">{{subject}}</option>
    </select> -->
    <div class="UNFAPP-chptr-insight-btn-area">
        <button class="UNFAPP-insight-btn" [ngClass]="{'active':getbtnName == 'strong'}"
            (click)="loadChapter('strong')">Strong</button>
        <button class="UNFAPP-insight-btn" [ngClass]="{'active':getbtnName == 'good'}"
            (click)="loadChapter('good')">Good</button>
        <button class="UNFAPP-insight-btn" [ngClass]="{'active':getbtnName == 'improve'}"
            (click)="loadChapter('improve')">Improve</button>
    </div>
    <ng-container *ngIf="chaptersData.length > 0">
        <div class="UNAPP-desk-insight-area">
            <ng-container *ngIf="chaptersData.length == 1">
                <ng-container *ngTemplateOutlet="insightCards"></ng-container>
            </ng-container>
            <ng-container *ngIf="chaptersData.length > 1">
                <carousel #myCarousel class="UNFAPP-insight-carousel" [ngClass]="{'hidearrow' : chaptersData.length < 4}" [height]="couraselHeight" [margin]="16" [cellWidth]="320"
                    [freeScroll]="false">
                    <ng-container *ngTemplateOutlet="insightCards"></ng-container>
                </carousel>
            </ng-container>
            
        </div>
        <div class="UNAPP-mweb-insight-area">
            <ng-container *ngTemplateOutlet="insightCards"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="!chaptersData?.length">
        <div class="UNAPP-insight-nocontent">
        <ng-container [ngSwitch]="getbtnName">
            <ng-container *ngSwitchCase="'strong'">
                <img src="assets/img/improve-star-animation.gif" class="UNAPP-insight-icn" />
                <div class="UNAPP-insight-content-wrap">
                    <h2>No strong chapter</h2>
                    <p>You can Improve your performance <br>by working on your concepts</p>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'good'">
                <img src="assets/img/good-star-animation.gif" class="UNAPP-insight-icn" />
                <div class="UNAPP-insight-content-wrap">
                    <h2 class="d-hide">No chapters</h2>
                    <h2 class="m-hide">No Chapters</h2>
                    <p>You can pratice more & improve <br>your score</p>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'improve'">
                <img src="assets/img/strong-star-animation.gif" class="UNAPP-insight-icn" />
                <div class="UNAPP-insight-content-wrap">
                    <h2>Good Job!</h2>
                    <p>You have scored good marks.</p>
                </div>
            </ng-container>
        </ng-container>
        </div>
    </ng-container>
</div>
<ng-template #insightCards>
    <div class="carousel-cell" *ngFor="let chapter of chaptersData;let index =  index">
        <div class="UNFAPP-insight-box"  
            [ngClass]="{'blue' :getbtnName == 'good' , 'orange': getbtnName == 'improve', 'collaps' : chapter?.open}">
       
            <div class="UNFAPP-insight-box-hrd" (click)="changeCarouselHeight(index,$event) ">
                <h5 class="UNFAPP-insight-box-hrd-title">{{chapter?.chapterName}}</h5>
                <h6 class="UNFAPP-insight-box-hrd-subtitle"><b>{{chapter?.totalScore| number:'2.0'}}/ {{chapter?.totalMarks| number:'2.0'}}</b>
                    marks</h6>
                <button class="UNFAPP-insight-expnd-btn"  ></button>
            </div>
            <div class="UNFAPP-insight-box-cnt-area">
                <app-barline class="UNFAPP-insight-barline barline-1st" [data]="chapter?.correctAnswer"
                    [type]="'Correct'" [chartOptions]="chartType?.attempted" [totalData]="chapter" [testReport]="testReportCopy" [viewSolutionAvailableTimebound] ="viewSolutionAvailableTimebound"></app-barline>
                <app-barline class="UNFAPP-insight-barline barline-2nd" [data]="chapter?.incorrectAnswer"
                    [type]="'Incorrect'" [chartOptions]="chartType?.incorrect" [totalData]="chapter" [testReport]="testReportCopy" [viewSolutionAvailableTimebound] ="viewSolutionAvailableTimebound"></app-barline>
                <app-barline class="UNFAPP-insight-barline barline-3rd" [data]="chapter?.unattempted"
                    [type]="'Unattempted'" [chartOptions]="chartType?.unattempted" [totalData]="chapter" [testReport]="testReportCopy" [viewSolutionAvailableTimebound] ="viewSolutionAvailableTimebound"></app-barline>
            </div>
        </div>

    </div>
</ng-template>